
import { defineComponent } from "vue";
import { MutationTypes } from "./store/mutation-types";

export default defineComponent({
    name: "App",
    mounted() {
        console.log("mounted");
        if ((process.env.VUE_APP_MODE || "").indexOf("Production") >= 0 || (process.env.VUE_APP_MODE || "").indexOf("Staging") >= 0) {
            let host = window.location.host;
            host = host.replace("admin", "api");
            this.$store.commit(MutationTypes.SET_APIURL, window.location.protocol + "//" + host + "/");
            console.log("apiURL", window.location.protocol + "//" + host + "/");
        } else {
            this.$store.commit(MutationTypes.SET_APIURL, process.env.VUE_APP_API_URL);
            console.log("apiURL", process.env.VUE_APP_API_URL);
        }
    },
});
